import { FC, ReactElement } from 'react';

import Linear from '../Linear';
import Spinner from '../Spinner';

import './Loader.scss';

import { SizeOptions, TestMetadata } from '../types';

type LoaderType = 'spinner' | 'linear';

export interface LoaderProps {
  /** Text to display above the loader */
  text?: string;
  /** Size of the loader */
  size: SizeOptions;
  /** Custom class name for the component */
  className?: string;
  /** Type of loader (Spinner default) */
  type?: LoaderType;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const loader = (type: LoaderType, size: SizeOptions): ReactElement => {
  switch (type) {
    case 'linear':
      return <Linear size={size} />;
    case 'spinner':
    default:
      return <Spinner size={size} loadText="" />;
  }
};

const Loader: FC<LoaderProps> = ({
  className,
  text,
  type = 'spinner',
  size,
  testMetadata,
  ...otherProps
}) => (
  <div
    {...otherProps}
    role="progressbar"
    className={className}
    {...testMetadata}
  >
    {text && <div className="sb-loader-text">{text}</div>}
    {loader(type, size)}
  </div>
);

export default Loader;
